import React from "react";
import { Item } from "../models/Item";
import { useNavigate } from "react-router-dom";

export const TabComponent = (props: Item) => {
    const navigate = useNavigate();

    const onClick = () => {
        if (props.onClick) {
            props.onClick();
        } else {
            navigate(props.redirect ?? '');
        }
    }

    return (
        <div className="tabs-element button-style glowd-on-hover"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            onClick={onClick}
        >
            <div className="content">
                <div className="title">
                    {props.title}
                </div>
                <span>{props.img}</span>
            </div>
        </div>
    )
}
